import { ArrowDownToLine } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  onClick: () => void
}

export const DownloadButton: React.FC<Props> = ({ onClick }) => {
  return (
    <button type="button" onClick={onClick} className={css.download_button}>
      <ArrowDownToLine /> Invoice
    </button>
  )
}
